import { useEffect } from 'react'
import { isBrowser } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useTheme } from '@emotion/react'
import {
  closeModal,
  resetOrder,
  resetQuote,
  selectAnnouncementsPage,
  selectBrand,
  selectContentSection,
  selectCustomer,
  selectQuote,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  BackgroundContent,
  Content,
  HeaderSite,
  Main,
  PageIntro,
} from 'components'
import PageHero from '../../PageHero'
import { useAnnouncementPage } from 'hooks'

const Home = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { colors } = useTheme()
  const brand = useAppSelector(selectBrand)
  const { background, mobile, title, subtitle, content } =
    useAppSelector(selectContentSection('home')) || {}
  const hasContent = !!(content && content.length)
  const announcements = useAppSelector(selectAnnouncementsPage('HOME'))
  const { auth } = useAppSelector(selectCustomer)
  const isQuote = useAppSelector(selectQuote)

  useEffect(() => {
    if (isQuote.order) {
      dispatch(resetQuote())
      dispatch(resetOrder())
    }
  }, [dispatch, isQuote])

  useEffect(() => {
    dispatch(closeModal())
  }, [dispatch])

  useEffect(() => {
    navigate(auth ? '/account' : '/guest')
  }, [navigate, auth])

  useAnnouncementPage('HOME')

  return (
    <>
      <Helmet>
        <title>{brand?.title}</title>
      </Helmet>
      <Content>
        <HeaderSite />
        <Main style={{ paddingTop: '0' }}>
          <PageHero
            announcements={announcements}
            imageUrl={isBrowser ? background : mobile}
          >
            <BackgroundContent
              title={title ?? ''}
              subtitle={subtitle ?? ''}
              title_color={colors.light}
              subtitle_color={colors.light}
              vertical="BOTTOM"
              horizontal="LEFT"
            />
          </PageHero>
          {hasContent ? <PageIntro content={content} /> : <></>}
        </Main>
      </Content>
    </>
  )
}

export default Home
